import { Component, OnInit, HostListener } from '@angular/core';
import { MemoryService } from '../../service/memory.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { BreakDialog } from '../dialogs/break/break.dialog';
import { LoadingDialog } from '../dialogs/loading/loading.dialog';
import { FeedbackDialog } from '../dialogs/feedback/feedback.dialog';
import { FeedbackCountDialog } from '../dialogs/feedbackCount/feedbackCount.dialog';
import { TranslateService } from '@ngx-translate/core';
import { TaskService } from 'src/app/service/tasks.service';


@Component({
  selector: 'app-memory-experiment',
  templateUrl: './memory-experiment.component.html',
  styleUrls: ['./memory-experiment.component.css']
})
export class MemoryExperimentComponent implements OnInit {

  started = false;

  selected: string;
  demo = true; // erreti: set back to true
  //demo = false;
  block = 0;
  round = 0;
  fase = 0;


  //words list divided per task
  aliveData = { demo: [], live: [] }
  manmadeData = { demo: [], live: [] }
  recognitionData = []
  currentLiveData = {};
  currentDemoData = []
  currentAnswers = []

  demoAnswerCorrectness: boolean //used to give feedback during categorisation demo (true-->correct, false-->wrong)
  recognitionTask: string = 'oldNew' //can be "oldNew" or "source"
  overview: boolean = true //controls the display of initial overview of taks
  dialogOpen: boolean = false //when true inputs from keyboard are disabled
  correctAnswersCount: number = 0
  answersCount = 0

  response = {
    categorisation: [],
    recognition: []
  }
  //used to decide whether execute before manmade and then alive or viceversa. Recognition is always after both.
  experimentOrder = [["alive", "manmade", "recognition", "done"], ["manmade", "alive", "recognition", "done"]]
  //experimentOrder = [["recognition", "manmade", "recognition", "done"], ["recognition", "alive", "recognition", "done"]]

  selectedOption: string[];
  ready = false;
  done = false;
  charged2 = false
  testFinished = false
  getReady = false
  time_of_showing_word=[];

  constructor(
    private router: Router,
    private memoryService: MemoryService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private taskService: TaskService
  ) { }

  ngOnInit() {
    //randomly choose the order (manmade then alive OR alive then manmade)
    this.selectedOption = this.experimentOrder[Math.floor(Math.random() * this.experimentOrder.length)];

    this.memoryService.check_exp()
      .then(data => {
        this.done = data.body.valid
        this.charged2 = true
        if (this.done) {

          this.memoryService.getBlocks().then(resp => {
            if (resp.status === 200) {
              const body = resp.body;

              this.aliveData.demo = body['demo_alive_task']
              this.aliveData.live = body['live_alive_task']
              this.manmadeData.demo = body['demo_manmade_task']
              this.manmadeData.live = body['live_manmade_task']

              //for recognition data put together data from alive, manmade and
              //body['retrieval_task'] (words not belonging to any of the two lists)
              //then mix them randomly. Finally divide into 4 blocks

              //put together all words
              let recognitionDataTemp = body['live_alive_task']
                .concat(body['live_manmade_task'])
                .concat(body['retrieval_task'])

              //randomly mix words
              recognitionDataTemp = this.shuffleArray(recognitionDataTemp)

              //divide into 4 blocks of 50 words
              let recognitionBlocks: any[] = [[], [], [], []]
              let blockNum: number = 0
              recognitionDataTemp.forEach((word: any, index: number) => {

                //every 50 words move to next block
                if (index !== 0 && index % 50 === 0) {
                  blockNum++
                }
                recognitionBlocks[blockNum].push(word)
              })

              //store recognition data into class attribute
              this.recognitionData = recognitionBlocks

              //stop loading
              this.ready = true


              this.updateDemoAndLiveData()

            }
            else if (resp.status === 201) {
              this.fase = 4
              this.ready = true
            }
          })
            .catch(e => {
              console.log(e);
            });
        }
      })

  }


  //randomizes array content
  private shuffleArray(array: any[]): any[] {
    let tempArr = [...array]
    array.reverse().forEach((_item, index) => {
      const j = Math.floor(Math.random() * (index + 1));
      [tempArr[index], tempArr[j]] = [tempArr[j], tempArr[index]];
    });
    return tempArr;
  }

  start = () => {
    this.getReady = true
    if(this.getReady==true && this.demo==false){
    //console.log("getReady inizio dopo 5 secondi")

    this.time_of_showing_word.push(this.timestamp());

    //console.log("risultato:"+this.time_of_showing_word.length+this.time_of_showing_word);
    }
    setTimeout(() => {
      this.correctAnswersCount = 0
      this.answersCount = 0
      this.getReady = false
      this.started = true
    }, 5000) //erreti: set back to 5000

  }

  startRecognition = () => {
    this.getReady = true
    setTimeout(() => {
      this.correctAnswersCount = 0
      this.answersCount = 0
      this.getReady = false
      this.started = true
    }, 0) // To solve the waiting problem after clicking start during Recognition

  }

  timestamp() {
    const date = new Date()
    let dateAux = date.toISOString()
    dateAux = dateAux.replace("T", " ")
    dateAux = dateAux.replace("Z", "")
    return dateAux;
  }

  clearState = () => {
    this.round = 0
    //console.log("sono qui round=0")
    this.started = false
    this.currentAnswers = []
    this.demo = true

    //this.correctAnswersCount = 0
    //this.answersCount = 0
  }

  updateDemoAndLiveData = () => {
    switch (this.selectedOption[this.fase]) {
      case 'alive':
        this.currentDemoData = [...this.aliveData.demo]
        this.currentLiveData = [...this.aliveData.live]
        break;
      case 'manmade':
        this.currentDemoData = [...this.manmadeData.demo]
        this.currentLiveData = [...this.manmadeData.live]
        break;
      case 'recognition':
        this.currentLiveData = [...this.recognitionData]
        break
    }
  }

  submitTask(type: String) {

    if (type === 'categorisation') {
      //console.log("RISPOSTE CORRENTIIIIII")
      //console.log(this.currentAnswers)
      //console.log(this.time_of_showing_word)
      for (let i in this.currentAnswers){
        let temp=this.currentAnswers[i].timestamp;
        this.currentAnswers[i].timestamp=this.time_of_showing_word[i]+ "_"+temp;
      }
      //console.log(this.currentAnswers)
      this.time_of_showing_word=[]
      this.response.categorisation = this.response.categorisation.concat(this.currentAnswers) //save answers
      this.clearState()
      this.fase++ //next fase

      this.updateDemoAndLiveData()
    }

    else if (type === 'recognition') {
      this.response.recognition = this.response.recognition.concat(this.currentAnswers) //save answers
      this.clearState()
      if (this.block === 3) { //BLOCK goes from 0 to 3
        this.block++
        setTimeout(() => {
          this.submit()
        }, 5000)
        //this.fase++
      }
      else {
        this.block++
      }
    }
  }

  submit() {
    const data = { recognition: this.response.recognition, categorisation: this.response.categorisation }

    data.recognition = data.recognition.map((ans) => {
      if (ans.hasOwnProperty('choiceSource') === false)
        ans.choiceSource = ''
      if (ans.hasOwnProperty('timestampSource') === false)
        ans.timestampSource = ''
      return ans
    })
    //console.log(data.recognition)
    const dialogRef = this.dialog.open(LoadingDialog, { disableClose: true })
    this.memoryService.save(data).then(resp => {
      dialogRef.close()
      if (resp.status === 200) {
        this.testFinished = true
        setTimeout(() => {
          this.router.navigate(['']);
        }, 3000)
      }
    }) .then(() => {
      this.taskService.saveCompletedTask({ "type": "WordCategorization" })
    }).catch(e => {
      console.log(e);
    });
  }

  updateCorrectness = (correctness: boolean) => {
    this.demoAnswerCorrectness = correctness
  }

  updateCorrectAnswersCount = () => {
    this.correctAnswersCount++
  }

  resetCorrectAnswersCount = () => {
    this.correctAnswersCount = 0
  }

  checkRound = (taskType: String, answer: number) => {

    if (taskType === 'categorisation') {
      if (this.demo) {

        //Give feedback on answer correctness (only durnig demo)
        this.dialogOpen = true
        const dialogRef = this.dialog.open(FeedbackDialog, {
          data: {
            correctness: this.demoAnswerCorrectness,
            showTime: false
          }
        });

        //timeout to automatically close dialog
        setTimeout(() => dialogRef.close(), 900)

        dialogRef.afterClosed()
          .subscribe(() => {
            this.dialogOpen = false
            if (this.round == 14) {
              //END DEMO
              this.demo = false
              this.round = 0
              //console.log("round=0 1")
              this.started = false
            }

            else this.round++;
          })

      }
      else if (this.round == 64) {
        //END OF ALL 65 WORDS --> Submit then move to next task
        //first, show feedback
        this.dialogOpen = true
        const dialogRef = this.dialog.open(FeedbackCountDialog, {
          data: {
            type: 'count',
            correctAnswersCount: this.correctAnswersCount,
            totalAnswersCount: 65
          }
        });

        dialogRef.afterClosed()
          .subscribe(() => {
            this.dialogOpen = false

            //reset for next calculation
            this.correctAnswersCount = 0

            //submit after feedback modal is closed!
            this.submitTask(taskType)
          })

      }
      else {
        //BREAK AFTER 21 AND 42 WORDS
        if (this.round === 20 || this.round === 41) {
          this.dialogOpen = true //when true keyboard inputs are disabled
          const dialogRef = this.dialog.open(BreakDialog, { data: { feedback: false } });
          dialogRef.afterClosed()
            .subscribe(() => {
              this.dialogOpen = false
              this.getReady=true

              //console.log("getReady inizio dopo 5 secondi 222")

              this.started=false
              setTimeout(() => {
                this.getReady=false
                this.started=true
                //console.log("sono quiiiiii dopo la pausa")
                this.time_of_showing_word.push(this.timestamp())
                //console.log(this.time_of_showing_word)
                this.round++ //Move to next word

              }, 5000);
            })
        }

        if (!this.dialogOpen) {
          //console.log("sono quiiiiii ")
          this.time_of_showing_word.push(this.timestamp())
          //console.log(this.time_of_showing_word)
          this.round++ //Move to next word
        }
      }
    }
    else if (taskType === 'recognition') {

      //FEEDBACK UPDATE
      if (this.recognitionTask === 'oldNew') {
        if (answer != 3) { //i.e. not answered "not sure"
          this.answersCount++
          if (this.currentLiveData[this.block][this.round].hasOwnProperty('correctResponse') === true) {
            //console.log('OLD')
            //IT MEANS IT'S OLD
            if (answer >= 4)
              this.correctAnswersCount++
          }
          else {
            //console.log('NEW')
            //IT'S NEW and answered NEW --> CORRECT
            if (answer <= 2)
              this.correctAnswersCount++
          }
          //console.log('answersCount ' + this.answersCount)
          //console.log('correctAnswersCount ' + this.correctAnswersCount)
        }

        if (answer >= 4) //i.e. not sure, probably old or definitely old
          this.recognitionTask = 'source'
        else { //skip source recognition if answer is new or probably new
          if (this.round === 49) {
            this.round = 0
            //console.log("round=0 2")
            this.recognitionTask = 'oldNew'
            this.submitTask('recognition')
          }
          else
            this.round++
        }
      }
      else if (this.round === 49) {
        this.round = 0
        //console.log("round=0 3")
        this.recognitionTask = 'oldNew'
        this.submitTask('recognition')
      }
      else {
        this.recognitionTask = 'oldNew'
        this.round++
      }
    }

  }

  endOverview = () => {
    this.overview = false
  }

  computePercentage = () => {
    if (this.answersCount === 0)
      return 0
    return ((this.correctAnswersCount / this.answersCount) * 100).toFixed(0)
  }

}

export enum KEY_CODE {
  RIGHT_ARROW = 'ArrowRight',
  LEFT_ARROW = 'ArrowLeft'
}
export const words: any = { Alive: [{ word: "apple" }, { word: "dog" }, { word: "car" }, { word: "cat" }, { word: "mark" }, { word: "carrot" }, { word: "onion" }], manmade: [{ word: "onion" }, { word: "pipe" }, { word: "apple" }, { word: "carrot" }, { word: "snake" }, { word: "shirt" }, { word: "car" }] }
